/**
 * Master IB remote_ids with MT5 SVG Classic (MT5_STD) limit of 8 for their network.
 * PT-5380 (10431), PT-5406 (10742 network masters).
 *
 * Keep in sync with `bdswiss-graphql/schema/resolvers/account/mt5StdNetworkMasterIbIds.ts`.
 * Backend account creation walks the full affiliate upline chain; the dashboard uses
 * immediate IB ids from client metadata (see `collectNetworkIbIds` in accounts.ts).
 */
export const MT5_STD_NETWORK_MASTER_IB_IDS = [
  10431,
  10694,
  10721,
  10723,
  10734,
  10735,
  10737,
  10739,
  10742,
  10750,
  10752,
  10756,
  10762,
  10764,
  10766,
  10771,
  10772,
  10779,
  10780,
  10782,
  10789,
  10797,
  10799,
  10803,
  10806,
  10821,
  10824,
  10847,
  10848,
  10853,
  10865,
  10869,
  10874,
  10879,
  10881,
  10885,
  10887,
  10894,
  10895,
  10896,
  10898,
  10901,
  10906,
  10907,
  10908,
  10912,
  10915,
  10918,
  10920,
  10921,
  10922,
] as const

export const MT5_STD_NETWORK_LIMIT = 8

export const MT5_STD_LIMIT_OVERRIDE_BY_NETWORK_IB_ID: Record<number, number> = Object.fromEntries(
  MT5_STD_NETWORK_MASTER_IB_IDS.map((id) => [id, MT5_STD_NETWORK_LIMIT]),
) as Record<number, number>
